export enum CommonActionType {
  SET_LAYOUT_TYPE = 'SET_LAYOUT_TYPE',
  SET_GRID_LAYOUT_TYPE = 'SET_GRID_LAYOUT_TYPE',
  SET_DARK_MODE = 'SET_DARK_MODE',
  SET_SELECTED_VALUE = "SET_SELECTED_VALUE",
  SET_SELECTED_PRODUCT = "SET_SELECTED_PRODUCT",
  SET_SELECTED_OS = "SET_SELECTED_OS"
}
